/**
 * Public registry surface — re-exports split modules for backward compatibility.
 */
export {
  BLOCK_CATEGORIES,
  BLOCKS_REGISTRY,
} from './blocks-registry-entries'

export {
  BLOCK_TYPE_ALIASES,
  LEGACY_TO_BLOCK,
  BLOCK_TYPE_IDS,
  BLOCK_LAUNCHER_ENTRIES,
  resolveBlockType,
  isBlockType,
  blockRegistryEntry,
} from './blocks-registry-resolve'

export { getBlockDefaultData } from './blocks-registry-defaults'

export {
  migrateSectionPayload,
  createEmptyTabsBlockData,
} from './blocks-registry-migrate'
